import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useTranslation } from "react-i18next";
import location from "../images/location.png";

export const ContactUs = ({
    address,
    city,
    contactUs,
}: {
    address: string;
    city: string;
    contactUs: string;
}) => {
    const { t } = useTranslation();

    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger
                asChild
                className="cursor-pointer px-4 py-2 font-normal text-base hover:bg-black hover:text-white"
            >
                <div>{t("Footer.contactUs")}</div>
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
                <DropdownMenu.Content
                    className="min-w-[220px] rounded-t-md bg-black w-[420px]
                        shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),_0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)]
                        will-change-[opacity,transform] 
                        data-[side=top]:animate-slideDownAndFade
                    "
                    sideOffset={1}
                    side="top"
                >
                    <DropdownMenu.Item
                        className="px-4 pt-4 pb-2 text-[#606060]  font-normal text-base

                        focus-visble:border-none
                        focus-visible:outline-none"
                    >
                        <div className="flex flex-row justify-start item-start gap-1">
                            <img
                                className="w-[22px] h-full"
                                src={location}
                                alt=""
                            />
                            {address}
                            <br />
                            {city}
                        </div>
                    </DropdownMenu.Item>
                    <DropdownMenu.Item
                        className="pl-[42px] pr-4 pt-2 pb-4 font-normal text-base
                        cursor-pointer 
                        focus-visble:border-none
                        focus-visible:outline-none"
                    >
                        <a
                            href={`mailto:${contactUs}`}
                            className="text-[#9B9B9B] hover:text-white no-underline"
                        >
                            {t("Footer.contactEmail")}
                        </a>
                    </DropdownMenu.Item>
                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    );
};
